import {useBooleanFlagValue} from "@openfeature/react-sdk";
import flags from "../features/featureFlags/flags";
import {useSelector} from "react-redux";
import {selectIsMobileApp} from "../store/reducers/runtimeDetails";

const useAppModernisation = () => {
    const isAppModernisationEnabled = useBooleanFlagValue(flags.APP_MODERNISATION, false);
    const isMobileApp = useSelector(selectIsMobileApp);
    const isForceAppMode = useBooleanFlagValue(flags.FORCE_APP_MODE, false);
    const isEnhancedSearchEnabled = useBooleanFlagValue(flags.ENHANCED_SEARCH, false);
    const isAppMode = isAppModernisationEnabled && (isMobileApp || isForceAppMode);
    const isEnhancedCounter = useBooleanFlagValue(flags.ENHANCED_COUNTER, false);
    return { isAppMode, isEnhancedSearchEnabled, isEnhancedCounter }
};

export default useAppModernisation;
